import { useLocation, useHistory } from 'react-router-dom';
import {useEffect, useState} from 'react';
import {reducer, useSetStateReducer} from '../../../Custom Hooks/useMemorizedReducer/useMemorized.reducer';
import {initializeState} from '../Config/ManualRefinement.state';
import {useSetTimeout} from '../../../Custom Hooks/useSetTimeout/useSetTimeout';
import {IClass, IImageManual} from '../Config/ManualRefinement.types';
import {request} from '../../../services/HttpRequestService';
import {storageService} from '../../../services/storageService';
import {BackendManualRefinementImagesField} from '../../../configuration/backendFileds/backendFileld.config';
import useBowserNavigation from '../../../Custom Hooks/useBowserNavigation/useBowserNavigation';
import utilService from '../../../services/utilService';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {FLOW} from '../../RandomSampler/Config/RandomSampler.constants';

const useManualRefinement = () => {
    const location = useLocation();
    const history = useHistory();
    const { state } = location;
    const { projectIdInit, classes, flow, batchId } = state || {};
    const [isExitModal, setIsOpenExitModal] = useState(false);
    const [getState, setState] = useSetStateReducer(reducer, initializeState);
    const manualRefinementState = getState();
    const {_setTimeOut} = useSetTimeout();

    /**
     * when user wants to go back to auto project page
     */
    const goBackToAutoProject = () => {
        storageService.removeFromStorage('manualIndex');
        const newPath = utilService.replaceLastRoute('auto_classification_project_status');

        if (flow === FLOW.autoClasses) {
            history.push({
                pathname: `/${_SYSTEM_TITLES.classInventoryTabName}`,
                state: {},
            });
        } else {
            history.replace({
                pathname: newPath,
                state: {projectIdInit},
            });
            history.go(0);
        }

    };

    useBowserNavigation(goBackToAutoProject, null, null, true);

    /**
     * setManualImages - setManualImages
     * @param images - manual Images
     */
    const setManualImages = (images) => {
        const newImages:IImageManual[] = [];

        images.forEach((img) => {
            newImages.push({
                title: img[BackendManualRefinementImagesField.name],
                manualRefinementId: img[BackendManualRefinementImagesField.manualRefinementId],
                url: img[BackendManualRefinementImagesField.url],
                approved: img.approved,
                isBest: img[BackendManualRefinementImagesField.isBest],
                subClusterId: img[BackendManualRefinementImagesField.subClusterId]
            });
        });

        return newImages;
    };

    /**
     * setManualImagesForDb - setManualImagesForDb
     * @param images - manual Images
     */
    const setManualImagesForDb = (images) => {
        const newImages:any = [];

        images.forEach((img) => {
            newImages.push({
                [BackendManualRefinementImagesField.name]: img.title,
                [BackendManualRefinementImagesField.manualRefinementId]: img.manualRefinementId,
                [BackendManualRefinementImagesField.isBest]: img.isBest,
                [BackendManualRefinementImagesField.detectedClass]: img.detectedClass,
                [BackendManualRefinementImagesField.subClusterId]: img.subClusterId
            });
        });

        return newImages;
    };

    /**
     * updateManualRefinementData - update data from Server
     */
    const updateManualRefinementData = async (manualImagesCopy) => {
        try {
            const req = {
                manual_refinement_images: setManualImagesForDb(manualImagesCopy),
                project_id: projectIdInit,
                current_class_cluster_id: manualRefinementState.classes[manualRefinementState.index].clusterId,
                tag_id: manualRefinementState.classes[manualRefinementState.index].tagId,
                flow,
                batch_id: batchId
            };

            await request.post(storageService.loadFromStorage('token'), 'UPDATE_MANUAL_REFINEMENT', req);

        } catch (e) {
            setState({isErrorPage: true});
        }
    };

    /**
     * getManualRefinementData - get data from Server
     */
    const getManualRefinementData = async () => {
        try {
            const req = {
                project_id: projectIdInit,
                class_cluster_id: 'clusterId' in manualRefinementState.classes[manualRefinementState.index] ? manualRefinementState.classes[manualRefinementState.index].clusterId : null,
                tag_id: manualRefinementState.classes[manualRefinementState.index].tagId,
                flow
            };


            const res = await request.post(storageService.loadFromStorage('token'), 'GET_MANUAL_REFINEMENT', req);
            const {manual_refinement_images, reference_images, project_classes} = res.data;
            const manualImages = JSON.parse(JSON.stringify(setManualImages(manual_refinement_images)));
            const referenceImages = JSON.parse(JSON.stringify(reference_images));
            const allProjectClasses = JSON.parse(JSON.stringify(project_classes));

            setState({manualImages, referenceImages, allProjectClasses});
        } catch (e) {
            setState({isErrorPage: true});
        }
    };

    /**
     * setCLasses - set classes to page type
     * @param classes - classes from status page
     * @param flow - the flow that invoked the process
     */
    const setCLasses = (classes, flow) => {
        const newClasses:IClass[] = [];

        classes.forEach((cur_class) => {
            if (flow === FLOW.autoClasses || cur_class.flowPhase === 1) {
                const newClass = {
                    tagId: cur_class.tag_id,
                    name: cur_class.tag_name,
                    clusterId: 'classClusterId' in cur_class ? cur_class.classClusterId : null
                };

                newClasses.push(newClass);
            }
        });

        return newClasses;
    };

    useEffect(() => {
        const index = manualRefinementState.index;
        // const index = typeof storageService.loadFromStorage('manualIndex') !== 'string' ? parseInt(storageService.loadFromStorage('manualIndex'), 10) : manualRefinementState.index;

        setState({classes: setCLasses(classes, flow), index: index + 1});
    }, []);

    useEffect(() => {
        (async () => {
            const manualImagesCopy = JSON.parse(JSON.stringify(manualRefinementState.manualImages));

            if (manualRefinementState.isMoveToAnotherClass) {
                await updateManualRefinementData(manualImagesCopy);
                if (manualRefinementState.index < manualRefinementState.classes.length - 1) {
                    storageService.saveToStorage('manualIndex', manualRefinementState.index);
                    setState({isCleanClick: true, manualImages: [], referenceImages: []});
                    _setTimeOut(() => {
                        setState({index: manualRefinementState.index + 1, isMoveToAnotherClass: false, isCleanClick: false});
                    }, 2000);
                } else {
                    goBackToAutoProject();
                }
            }
        })();
    }, [manualRefinementState.isMoveToAnotherClass]);

    useEffect(() => {
        manualRefinementState.index > -1 && getManualRefinementData();
    }, [manualRefinementState.index]);

    return {goBackToAutoProject, isExitModal, setIsOpenExitModal, manualRefinementState, setState};
};

export default useManualRefinement;
